/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Menu from '../menus/Menu';
import Title from '../typography/Title';

import styles from '../../../styles/partials/sidebar.module.css';

const propTypes = {
    title: PropTypes.node,
    menu: PropTypes.arrayOf(PropTypes.shape({})),
    button: PropTypes.shape({}),
    className: PropTypes.string,
    children: PropTypes.node,
};

function Sidebar({ title = null, menu = null, className = null, children = null }) {
    return (
        <div className={classNames([styles.container, { [className]: className !== null }])}>
            <aside className={styles.side}>
                {menu !== null && menu.length > 0 ? (
                    <Menu
                        className={styles.menu}
                        itemsClassName={styles.menuItems}
                        itemClassName={styles.menuItem}
                        activeItemClassName={styles.activeMenuItem}
                        items={menu}
                    />
                ) : null}
            </aside>
            <div className={styles.content}>
                {title !== null ? (
                    <Title className={styles.title} size="medium">
                        {title}
                    </Title>
                ) : null}

                {children}
            </div>
        </div>
    );
}

Sidebar.propTypes = propTypes;

export default Sidebar;
